import { TableViewColumnDefinition } from '@components/UI-Components/StandardTableView/models/TableViewColumnDefinition'
import { clientOrderManagementTableViewColumnIdentifiers } from '@modules/common/models/enums/ClientOrderManagementTableViewColumnIdentifiers'
import { clientOrderManagementTableViewColumnLabel } from '@modules/common/models/enums/ClientOrderManagementTableViewColumnLabel'
import { ColumnWidth } from '@modules/common/models/enums/ColumnWidth'
import { clientOrderManagementTableFieldViewMapping } from '@modules/common/models/enums/OrderManagementTableFieldViewMapping'
import { TextAlignment } from '@modules/common/models/enums/TextAlignment'
import { orderManagementComponentService } from '@modules/wholesale/orderManagement/container/OrderManagementComponentService'
import { stores } from '@stores'

class OrderManagementTableDefinitionService {
  buildTableViewDefinitionForOrderManagement = (
    isGMOrAdmin: boolean,
    isRTLOrderView: boolean
  ) => {
    const {
      orderManagementStore: { deletedOrdersTabView }
    } = stores

    let width = ColumnWidth.ICON
    if (deletedOrdersTabView) {
      width = ColumnWidth.RestoreIcon
    }
    // Common columns
    const actions = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.actions,
      isRootColumn: true,
      isFixed: true,
      width: width,
      header: {
        label: ''
      },
      node: {
        key: '',
        disableKey: clientOrderManagementTableFieldViewMapping.IsDeleteStatusDisabled,
        component: orderManagementComponentService.getActionsComponent
      }
    })
    const clientName = new TableViewColumnDefinition({
      id: isRTLOrderView
        ? clientOrderManagementTableViewColumnIdentifiers.zoneName
        : clientOrderManagementTableViewColumnIdentifiers.clientName,
      isFixed: true,
      width: ColumnWidth.Medium,
      header: {
        label: isRTLOrderView
          ? clientOrderManagementTableViewColumnLabel.zoneName
          : clientOrderManagementTableViewColumnLabel.ClientName
      },
      props: {
        fontSize: 'Bold 12px Roboto'
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.ClientName,
        labelKey: isRTLOrderView
          ? clientOrderManagementTableFieldViewMapping.ZoneName
          : clientOrderManagementTableFieldViewMapping.ClientName,
        disableKey: clientOrderManagementTableFieldViewMapping.ClientDisabled,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const clientCode = new TableViewColumnDefinition({
      id: isRTLOrderView
        ? clientOrderManagementTableViewColumnIdentifiers.zoneCode
        : clientOrderManagementTableViewColumnIdentifiers.clientCode,
      isFixed: true,
      width: ColumnWidth.Medium,
      header: {
        label: isRTLOrderView
          ? clientOrderManagementTableViewColumnLabel.zoneCode
          : clientOrderManagementTableViewColumnLabel.clientCode
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.ClientCode,
        labelKey: isRTLOrderView
          ? clientOrderManagementTableFieldViewMapping.ZoneCode
          : clientOrderManagementTableFieldViewMapping.ClientCode,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const order = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.order,
      isFixed: true,
      width: ColumnWidth.Large,
      header: {
        label: clientOrderManagementTableViewColumnLabel.order
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.OrderNumber,
        component: orderManagementComponentService.getLinkComponent
      },
      showColumnFilter: true
    })
    const country = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.country,
      width: ColumnWidth.Small,
      header: {
        label: clientOrderManagementTableViewColumnLabel.country
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Country,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const doors = new TableViewColumnDefinition({
      id: isRTLOrderView
        ? clientOrderManagementTableViewColumnIdentifiers.stores
        : clientOrderManagementTableViewColumnIdentifiers.doors,
      width: ColumnWidth.Medium,
      props: {
        cellPadding: '0px'
      },
      header: {
        label: isRTLOrderView
          ? clientOrderManagementTableViewColumnLabel.stores
          : clientOrderManagementTableViewColumnLabel.doors
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Doors,
        labelKey: isRTLOrderView
          ? clientOrderManagementTableFieldViewMapping.Stores
          : clientOrderManagementTableFieldViewMapping.Doors,
        component: orderManagementComponentService.getMenuComponent
      },
      showColumnFilter: true
    })
    const creationDate = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.creationDate,
      width: ColumnWidth.Medium,
      header: {
        label: clientOrderManagementTableViewColumnLabel.creationDate
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.CreationDate,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const globalValue = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.globalValue,
      width: ColumnWidth.Medium,
      header: {
        label: clientOrderManagementTableViewColumnLabel.globalValue
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.globalValue,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const value = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.value,
      width: ColumnWidth.Medium,
      header: {
        label: clientOrderManagementTableViewColumnLabel.value
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Value,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const qty = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.qty,
      width: ColumnWidth.XS,
      header: {
        label: clientOrderManagementTableViewColumnLabel.qty
      },
      props: {
        alignment: TextAlignment.right
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Qty,
        component: orderManagementComponentService.getLabelComponent
      },
      showColumnFilter: true
    })
    const activityGender = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.activityGender,
      width: ColumnWidth.Large,
      header: {
        label: clientOrderManagementTableViewColumnLabel.activityGender
      },
      props: {
        cellPadding: '0px'
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.ActivityGender,
        component: orderManagementComponentService.getMenuComponent
      },
      showColumnFilter: true
    })
    const status = new TableViewColumnDefinition({
      id: clientOrderManagementTableViewColumnIdentifiers.status,
      width: ColumnWidth.Status,
      header: {
        label: clientOrderManagementTableViewColumnLabel.status,
        action: {
          component: orderManagementComponentService.getBulkUpdateComponentForStatusChange
        }
      },
      node: {
        key: clientOrderManagementTableFieldViewMapping.Status,
        disableKey: clientOrderManagementTableFieldViewMapping.IsEditStatusDisabled,
        component: orderManagementComponentService.getStatusComponent
      },
      showColumnFilter: true
    })
    let columnsDef = isRTLOrderView
      ? [
          actions,
          clientName,
          clientCode,
          order,
          country,
          doors,
          creationDate,
          globalValue,
          value,
          qty,
          activityGender,
          status
        ]
      : [
          actions,
          clientName,
          clientCode,
          order,
          country,
          doors,
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.shipTo,
            width: ColumnWidth.Medium,
            props: {
              cellPadding: '0px'
            },
            header: {
              label: clientOrderManagementTableViewColumnLabel.shipTo
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.ShipTo,
              component: orderManagementComponentService.getLabelComponent
            },
            showColumnFilter: true
          }),
          creationDate,
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.zam,
            width: ColumnWidth.Medium,
            header: {
              label: clientOrderManagementTableViewColumnLabel.zam
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.ZAM,
              component: orderManagementComponentService.getLabelComponent
            },
            showColumnFilter: true
          }),
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.salesAsst,
            width: ColumnWidth.Medium,
            header: {
              label: clientOrderManagementTableViewColumnLabel.salesAsst
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.SalesAssistant,
              component: orderManagementComponentService.getLabelComponent
            },
            showColumnFilter: true
          }),
          globalValue,
          value,
          qty,
          activityGender,
          status,
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.sapStatus,
            width: ColumnWidth.Medium,
            props: {
              alignment: TextAlignment.center,
              cellPadding: '0px'
            },
            header: {
              label: clientOrderManagementTableViewColumnLabel.sapStatus,
              action: isGMOrAdmin && {
                component:
                  orderManagementComponentService.getOrderManagementBulkStatusComponentForOpen
              }
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.SAPStatus,
              disableKey: clientOrderManagementTableFieldViewMapping.IsSendToSAPDisabled,
              component: orderManagementComponentService.getSendToSAPComponent
            },
            showColumnFilter: true
          }),
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.sapOrderNumber,
            width: ColumnWidth.Medium,
            header: {
              label: clientOrderManagementTableViewColumnLabel.sapOrderNumber
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.SAPOrderNumber,
              component: orderManagementComponentService.getLabelComponent
            },
            showColumnFilter: true
          }),
          new TableViewColumnDefinition({
            id: clientOrderManagementTableViewColumnIdentifiers.deliveryDate,
            width: ColumnWidth.DeliveryDate,
            header: {
              label: clientOrderManagementTableViewColumnLabel.deliveryDate
            },
            node: {
              key: clientOrderManagementTableFieldViewMapping.DeliveryDate,
              component: orderManagementComponentService.getDeliveryDateComponent,
              disableKey:
                clientOrderManagementTableFieldViewMapping.IsDeliveryDateDisabled
            },
            showColumnFilter: true
          })
        ]

    if (deletedOrdersTabView) {
      const columnsToBeRemoved = new Set<clientOrderManagementTableViewColumnIdentifiers>(
        [
          clientOrderManagementTableViewColumnIdentifiers.globalValue,
          clientOrderManagementTableViewColumnIdentifiers.value,
          clientOrderManagementTableViewColumnIdentifiers.qty
        ]
      )

      columnsDef = columnsDef.filter(
        col =>
          !columnsToBeRemoved.has(
            col.id as clientOrderManagementTableViewColumnIdentifiers
          )
      )
    }

    return columnsDef
  }
}

export const orderManagementTableDefinitionService =
  new OrderManagementTableDefinitionService()
